import { render } from "./BuscaAutocomplete.vue?vue&type=template&id=d4641106&scoped=true"
import script from "./BuscaAutocomplete.vue?vue&type=script&lang=js"
export * from "./BuscaAutocomplete.vue?vue&type=script&lang=js"

import "./BuscaAutocomplete.vue?vue&type=style&index=0&id=d4641106&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4641106"]])

export default __exports__